import { render } from "./index.vue?vue&type=template&id=1f020cf9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1f020cf9&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1f020cf9&lang=less"
script.render = render
script.__scopeId = "data-v-1f020cf9"

export default script